export default function PlaceProfileText({ cardPlace }) {
    return (
        <>
            <h2 className="featurette-heading fw-normal lh-1 pt-2">
                {cardPlace?.fromGoogle?.name ||
                    cardPlace?.fromGoogle?.formatted_address ||
                    cardPlace?.name}
            </h2>
            <hr className="w-50 mx-auto"></hr>
            <p className="lead mx-auto text-start" style={{ maxWidth: "none" }}>
                <span className="text-start lead">
                    {`${cardPlace?.cultural_sensitivity_overview}  `}
                </span>
                <span className="text-start lead">{`${cardPlace?.crime_overview}`}</span>
                <br></br>
                <br></br>
                <span className="text-start lead">{`${cardPlace?.air_quality_overview}  `}</span>
                <span className="text-start lead">{`${cardPlace?.medical_care_overview}  `}</span>
                <br></br>
                <br></br>
                <span className="text-start lead">{`${cardPlace?.weather_overview}  `}</span>
                <span className="text-start lead">{`${cardPlace?.environmental_overview}  `}</span>
                <br></br>
                <br></br>
                <span className="text-start lead">{`${cardPlace?.transportation_overview}  `}</span>
                <br></br>
                <br></br>
                <span className="text-start lead">{`${cardPlace?.political_stability_overview}  `}</span>
            </p>
        </>
    )
}
